import React from 'react';
import type { CurrencyCode } from '@noths/polaris-client-localisation';

import { Check } from './Check/Check';
import * as styles from './BlocksHeader.styles';

interface SharedBlocksHeaderProps {
  isSelected: boolean;
  label: string;
  onClick?: VoidFunction;
  onFocus?: VoidFunction;
  variant: 'check';
}

interface BlocksHeaderPropsWithPrice extends SharedBlocksHeaderProps {
  currency: CurrencyCode;
  price: number;
}

interface BlocksHeaderPropsWithoutPrice extends SharedBlocksHeaderProps {
  currency?: never;
  price?: never;
}

export type BlocksHeaderProps = BlocksHeaderPropsWithPrice | BlocksHeaderPropsWithoutPrice;

export const BlocksHeader = ({
  currency,
  isSelected,
  label,
  onClick,
  onFocus,
  price,
  variant,
}: BlocksHeaderProps) => {
  return (
    <div css={styles.blocksHeaderWrapper}>
      {variant === 'check' && (
        <Check
          currency={currency}
          isSelected={isSelected}
          label={label}
          onClick={onClick}
          onFocus={onFocus}
          price={price}
        />
      )}
    </div>
  );
};
